const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const newContractRouter = new VueRouter({
  routes: [
    {
      name: 'new-contract-01', // type selector
      path: '/',
      component: require('./components/pages/new-contract/01.vue').default
    },
    {
      name: 'new-contract-02', // contract person selector
      path: '/02/:type',
      component: require('./components/pages/new-contract/02.vue').default
    },
    {
      name: 'new-contract-03',
      path: '/03/:type',
      component: require('./components/pages/new-contract/03.vue').default
    },
    // {
    //   name: 'new-contract-03-money', // detail money
    //   path: '/03/money',
    //   component: require('./components/pages/new-contract/03-money.vue').default
    // },
    // {
    //   name: 'new-contract-03-thing', // detail money
    //   path: '/03/thing',
    //   component: require('./components/pages/new-contract/03-thing.vue').default
    // }
  ],
})

Vue.component('new-contract-entry', require('./components/pages/new-contract/Index.vue').default)

if ($('#new-contract-app').length) { // for new-contract-app
  const app = new Vue({
    router: newContractRouter
  }).$mount('#new-contract-app');
}